import LazyLoad from "react-lazyload";
import Breadcrumb from "../Component/Breadcrumb";
import Footer from "../Component/Footer";
import Header from "../Component/Header";
import Menu from "../Component/Menu";
import PageTitle from "../Component/PageTitle";
function advisoryBoard() {
  const homeMenu = [
    { label: "Vision", link: "/about" },
    {
      label: "Management",
      link: "",
      subMenu: [
        { label: "Director-Principal's Message", link: "/PrincipalMessage" },
        { label: "Leadership Team", link: "/leadershipTeam" },
        { label: "Patron’s Message", link: "/patrons" },
        { label: "Advisory Board", link: "/advisoryBoard" },
      ],
    },

    { label: "International Collaborations", link: "/partnership" },
    { label: "Awards & Achievements", link: "/awardsAcheivements" },
    { label: "Faculty", link: "/faculty" },
    { label: "Staff Details", link: "/staffDetails" },
    { label: "School Strength ", link: "/schoolStrength" },
    {
      label: "Gallery",
      link: "/Gallery",
      subMenu: [
        { label: "Photo Gallery", link: "/Gallery" },
        { label: "Video Gallery", link: "/VideoGallery" },
      ],
    },
  ];
  return (
    <>
      <Header />
      <Breadcrumb breadImage="https://entab-s3-bucket1.s3.ap-south-1.amazonaws.com/LVISGURGAON/public/Images/banner-partnership.jpg" />
      <Menu MenuItem={homeMenu} />
      <div className="padding-blk inner-page management-block">
        <div className="container-fluid">
          <div className="row">
            <div className="col-md-12">
              <PageTitle
                pageTitle="Management"
                breadEnd="Advisory Board"
                breadMid="Advisory Board"
              />
            </div>
          </div>
          <div className="row g-4">
            <div className="col-12">
              <h4 className="color-red">Advisory Board</h4>
            </div>
            <div className="col-12 leftimg">
              <div className="leftimg">
                <div className="card-body">
                  <LazyLoad>
                    {" "}
                    <img
                      src="https://entab-s3-bucket1.s3.ap-south-1.amazonaws.com/LVISGURGAON/public/Images/Ms_Jaspreet.jpeg"
                      className="img-fluid rounded-start"
                      alt="lotusvalleygurgaon"
                    />
                  </LazyLoad>
                  <h5 className="card-title">Mrs. Jaspreet Kaur</h5>
                  <p className="card-subtitle text-muted">Chairperson</p>
                  <p className="card-text">
                    Ms Jaspreet Kaur is a visionary who believes that
                    facilitating the inculcation of 21st-century skills and
                    values with love empowers learners to become responsible
                    global citizens. A dynamic and passionate leader, Ms Kaur
                    has ensured that Lotus Valley International School provides
                    holistic education in a joyful learning environment so that
                    our learners develop a lifelong love for learning.
                    Furthermore, her passionate belief that inclusive and
                    nurturing classrooms will pave the way to an inclusive
                    society has led to the effective adoption of inclusive
                    pedagogies based on fun-based and hands-on learning to
                    enable each child to learn and blossom.
                  </p>
                </div>
              </div>
            </div>
            <hr />
            <div className="col-12 leftimg">
              <div className="leftimg">
                <div className="card-body">
                  <LazyLoad>
                    {" "}
                    <img
                      src="https://entab-s3-bucket1.s3.ap-south-1.amazonaws.com/LVISGURGAON/public/Images/mr-aftab-seth-ifs.jpg"
                      className="img-fluid rounded-start"
                      alt="lotusvalleygurgaon"
                    />
                  </LazyLoad>
                  <h5 className="card-title">Mr. Aftab Seth IFS</h5>
                  <p className="card-subtitle text-muted">
                    Former Indian Diplomat
                  </p>
                  <p className="card-text">
                    <b>Member Managing Committee</b>
                    <br />
                    Mr. Aftab Seth is the Chairman of India Global Link Co.
                    Ltd., Japan-India Partnership Forum and Global Indian
                    International School of Tokyo. He is also Chairman of the
                    Global Indian International Schools Japan and Vice President
                    of the Global Schools Foundation in Singapore, which runs
                    schools in Vietnam, Malaysia, Indonesia, Thailand, UAE,
                    Japan and India. He was the Indian Ambassador to Japan,
                    Micronesia, Vietnam and Greece. After joining the Ministry
                    of External Affairs of India, he had served in the embassies
                    in Beirut, Cairo and Jakarta and the consulates in Karachi
                    and Hamburg. He is a Rhodes Scholar and holds a Doctorate in
                    Law from the American College of Greece along with a Post
                    Graduate degree from Christ Church College, Oxford
                    University.
                  </p>
                </div>
              </div>
            </div>
            <hr />
            <div className="col-12 leftimg">
              <div className="leftimg">
                <div className="card-body">
                  <LazyLoad>
                    {" "}
                    <img
                      src="https://entab-s3-bucket1.s3.ap-south-1.amazonaws.com/LVISGURGAON/public/Images/Ms_Sureena.jpeg"
                      className="img-fluid rounded-start"
                      alt="lotusvalleygurgaon"
                    />
                  </LazyLoad>
                  <h5 className="card-title">Mrs. Sureena Uppal</h5>
                  <p className="card-subtitle text-muted">
                    Member Managing Committee
                  </p>
                  <p className="card-text">
                    Ms Sureena Uppal has been the inspiration behind the
                    school’s incorporation of a gentle and creative way of
                    education that inculcates humanitarian ideals, wisdom and
                    compassion in learners and empowers them to appreciate the
                    uniqueness of others. She steadfastly works towards enabling
                    the holistic development of all learners and equipping them
                    with skills necessary to evolve as empathetic, optimistic,
                    self-assured and keen global citizens. The inclusive
                    programs implemented under her mentorship have provided
                    learners with global learning experiences while preserving
                    the core Indian values.
                  </p>
                </div>
              </div>
            </div>
            <hr />
            <div className="col-12 leftimg">
              <div className="leftimg">
                <div className="card-body">
                  <LazyLoad>
                    <img
                      src="https://entab-s3-bucket1.s3.ap-south-1.amazonaws.com/LVISGURGAON/public/Images/mr-b-s-baswan.jpg"
                      className="img-fluid rounded-start"
                      alt="lotusvalleygurgaon"
                    />
                  </LazyLoad>
                  <h5 className="card-title">Mr. B.S. Baswan</h5>
                  <p className="card-subtitle text-muted">
                    IAS (Retd)
                    <br />
                    Member Managing Committee
                  </p>
                  <p className="card-text">
                    Mr. B.S. Baswan is currently the Director of Indian
                    Institute of Planning and Administration and Former
                    Secretary, Department of Secondary and Higher Education,
                    MHRD, Govt. of India. A highly acclaimed academician, he is
                    an alumnus of Eaton House Preparatory School, London, The
                    Doon School, Dehradun, St. Stephen’s College, Delhi and
                    Elphinstone College, Mumbai. Mr Baswan has also attended
                    Victoria University, Manchester and Banff School of Advanced
                    Management, Canada.
                  </p>
                </div>
              </div>
            </div>
            <hr />
            <div className="col-12 leftimg">
              <div className="leftimg">
                <div className="card-body">
                  <LazyLoad>
                    {" "}
                    <img
                      src="https://entab-s3-bucket1.s3.ap-south-1.amazonaws.com/LVISGURGAON/public/Images/MADAN_LAL_SHARMA.png"
                      className="img-fluid rounded-start"
                      alt="lotusvalleygurgaon"
                    />
                  </LazyLoad>
                  <h5 className="card-title">Mr Madan Lal Sharma</h5>
                  <p className="card-subtitle text-muted">
                    Former Indian Cricketer
                    <br />
                    Member Managing Committee
                  </p>
                  <p className="card-text">
                    A recipient of Arjuna Award, Mr Madan Lal Sharma is a former
                    Indian Cricketer and Indian National Cricket Coach. He has
                    been an integral part of the golden era that changed the
                    face of Indian cricket in the ’80s. He was a member of the
                    winning Indian squads during the 1983 Cricket World Cup and
                    1985 Benson & Hedges World Championship of Cricket. Mr
                    Sharma has also been a National Selector for four years and
                    a Bowling coach at the National Cricket Academy, Bangalore.
                  </p>
                </div>
              </div>
            </div>
            <hr />
            <div className="col-12 leftimg">
              <div className="leftimg">
                <div className="card-body">
                  <LazyLoad>
                    <img
                      src="https://entab-s3-bucket1.s3.ap-south-1.amazonaws.com/LVISGURGAON/public/Images/Anita-Bhatnagar.jpg"
                      className="img-fluid rounded-start"
                      alt="lotusvalleygurgaon"
                    />
                  </LazyLoad>
                  <h5 className="card-title">Dr. Anita Bhatnagar</h5>
                  <p className="card-subtitle text-muted">
                    IAS (Retd)
                    <br />
                    Member Managing Committee
                  </p>
                  <p className="card-text">
                    Dr. Anita Bhatnagar Jain has served as Additional Chief
                    Secretary, Food Safety & Drug Administration and Higher
                    Education Department, Uttar Pradesh. As an officer from the
                    Indian Administrative Services, she served at various key
                    positions such as Commissioner of Kanpur Division,
                    Commissioner of NCR, Managing Director - UPSIDC, Director of
                    State Urban Development Agency, Vice Chairperson - Kanpur
                    Development Authority and District Magistrate Kanpur. She is
                    an environmental enthusiast and has been conferred with
                    ‘Paryavaran Shiromani’ by Chief Minister, Uttar Pradesh for
                    her contribution towards the conservation of environment.
                  </p>
                </div>
              </div>
            </div>
            <hr />
            <div className="col-12 leftimg">
              <div className="leftimg">
                <div className="card-body">
                  <LazyLoad>
                    {" "}
                    <img
                      src="https://entab-s3-bucket1.s3.ap-south-1.amazonaws.com/LVISGURGAON/public/Images/mrs-lushin-dubey.jpg"
                      className="img-fluid rounded-start"
                      alt="lotusvalleygurgaon"
                    />
                  </LazyLoad>
                  <h5 className="card-title">Mrs Lushin Dubey</h5>
                  <p className="card-subtitle text-muted">
                    Stage Actor and Director
                    <br />
                    Member Managing Committee
                  </p>
                  <p className="card-text">
                    Ms Lushin Dubey is an Indian stage actor and director. She
                    has been directing, acting and scripting drama productions
                    for over twenty years. Ms Dubey is known for her solo plays
                    ‘Untitled’ and Pinki Virani’s ‘Bitter Chocolate’ with
                    Theatre Director, Arvind Gaur. She acted in films like
                    Partition (2007), Murder Unveiled (2005) for which she had
                    won the 2006 Gemini Award for ‘An Actor in a Leading Role in
                    a Dramatic Program or Mini-Series’.
                  </p>
                </div>
              </div>
            </div>
            <hr />
            <div className="col-12 leftimg">
              <div className="leftimg">
                <div className="card-body">
                  <LazyLoad>
                    {" "}
                    <img
                      src="https://entab-s3-bucket1.s3.ap-south-1.amazonaws.com/LVISGURGAON/public/Images/Anjum-Chopra.jpg"
                      className="img-fluid rounded-start"
                      alt="lotusvalleygurgaon"
                    />
                  </LazyLoad>
                  <h5 className="card-title">Ms Anjum Chopra</h5>
                  <p className="card-subtitle text-muted">
                    First Indian Woman Cricketer
                    <br />
                    Member Managing Committee
                  </p>
                  <p className="card-text">
                    A Padma Shri recipient and an Arjuna Award winner, Ms Anjum
                    Chopra is both a former Test and One Day International
                    cricketer who has been recognized as the face of women's
                    cricket in India. In addition to having played in six World
                    Cups, Ms Chopra also became the first woman player to appear
                    in 100 ODIs for India along with being the first Indian
                    woman player to score an ODI century. Carving out a niche in
                    the male-dominated sport in the country, Ms. Anjum has made
                    a mark not only as a player and captain but also as a
                    consultant, motivational speaker, an author and anchor.
                  </p>
                </div>
              </div>
            </div>
            <hr />
            <div className="col-12 leftimg">
              <div className="leftimg">
                <div className="card-body">
                  <LazyLoad>
                    {" "}
                    <img
                      src="https://entab-s3-bucket1.s3.ap-south-1.amazonaws.com/LVISGURGAON/public/Images/Neelam-Pratap-Rudy.jpg"
                      className="img-fluid rounded-start"
                      alt="lotusvalleygurgaon"
                    />
                  </LazyLoad>
                  <h5 className="card-title">Mrs. Neelam Pratap Rudy</h5>
                  <p className="card-subtitle text-muted">
                    Social Activist
                    <br />
                    Member Managing Committee
                  </p>
                  <p className="card-text">
                    A recipient of the Super Achiever Award by Bharat Nirman, Ms
                    Rudy had served as the Chief of In-flight All India Services
                    and as a certified Instructor on Boeing 737 and ATR-200
                    aircrafts. She has been the organizer of Precious Golf Cup
                    tournament annually. Ms Rudy, Vice President, Women in
                    Aviation International (WAI) India Chapter firmly believes
                    that as a Developing Nation, India has to employ and help
                    women acquire skills for its growth. A philanthropist and
                    relentless benefactor, she is committed towards the
                    elevation of rural and homeless girls. Ms Rudy heads the
                    Ph.D. Chamber of Commerce and Industry's series of Mission –
                    ‘Beti Bachao, Beti Padhao and Beti Khelao’ programmes.
                  </p>
                </div>
              </div>
            </div>
            <hr />
            <div className="col-12 leftimg">
              <div className="leftimg">
                <div className="card-body">
                  <LazyLoad>
                    {" "}
                    <img
                      src="https://entab-s3-bucket1.s3.ap-south-1.amazonaws.com/LVISGURGAON/public/Images/HarkaranUppal.jpg"
                      className="img-fluid rounded-start"
                      alt="lotusvalleygurgaon"
                    />
                  </LazyLoad>
                  <h5 className="card-title">Harkaran Uppal</h5>
                  <p className="card-subtitle text-muted">
                    Member Managing Committee
                  </p>
                  <p className="card-text">
                    Harkaran Uppal is a key member of the Management Committee
                    at Lotus Valley Schools, where he has been contributing
                    since 2017.
                    <br />
                    Harkaran holds both a Master's degree in Urban Education
                    Policy and a Bachelor's degree in Economics and South Asian
                    Studies from Brown University. His academic and professional
                    interests lie at the intersection of education, political
                    science, history, and international relations, reflecting a
                    deep commitment to educational reform and policy
                    development.
                    <br />
                    With a global academic background and a strong grounding in
                    school leadership, Harkaran brings a thoughtful, analytical
                    approach to managing and enhancing the educational
                    experience at Lotus Valley Schools.
                  </p>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
      <Footer />
    </>
  );
}

export default advisoryBoard;
